export class counterPartyReport {
    reportDate!: Array<any>;
    destination:any;
    symbol:any;
    senderIMID: any;
}